import Styled from 'styled-components';

const Container = Styled.div`
	max-width: 1200px;
	margin: 0 auto;
	margin-top: 20px;
	text-align: center;
	padding: 10px;
`;
export default Container;